/* eslint-disable react/sort-comp */
// StockTranfer Component
import React, { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Decimal from 'decimal.js';
import {
  Table,
  Select,
  DatePicker,
  notification,
  Upload,
  Checkbox,
  Popover,
  Tooltip,
  Input,
} from 'antd';
import { v4 as uuidv4 } from 'uuid';
import {
  CloseOutlined,
  InfoCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import STActions from '@Actions/stActions';
import TenantActions from '@Actions/tenantActions';
import DepartmentActions from '@Actions/departmentActions';
import Helpers from '@Apis/helpers';
import Constants, { QUANTITY } from '@Apis/constants';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import CustomFieldV2 from '@Components/Common/CustomFieldV2';
import SelectDepartment from '@Components/Common/SelectDepartment';
import BatchSelector from '@Components/Inventory/Indent/CreateIndent/BatchSelector';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import './style.scss';
import SettingsInfo from '@Components/Common/SettingsInfo';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import FormHelpers from '@Helpers/FormHelpers';
import DocConfigActions from '@Actions/docConfigActions';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import H3FormInput from '@Uilib/h3FormInput';
import RichTextEditor from '../../../../Common/RichTextEditor';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import { getBatchesWithReservation } from '@Components/Inventory/StockTransfer/StockTransferForm/helper';
import PRZSelect from '../../../../Common/UI/PRZSelect';
import DocumentNumberSeqInput from '../../../../Admin/Common/DocumentNumberSeqInput';

const { Option } = Select;
const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

class StockTransferPR extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transferType: 'SAME BUSINESS',
      transferTypeValue: 1,
      visibleColumns: {
        PRODUCT: {
          label: 'Product',
          visible: true,
          disabled: true,
        },
        AVAILABLE_STOCK: {
          label: 'Available Stock',
          visible: true,
          disabled: true,
        },
        REQUESTED_QTY: {
          label: 'Requested Qty',
          visible: true,
          disabled: true,
        },
        PENDING_QTY: {
          label: 'Pending Qty',
          visible: true,
          disabled: true,
        },
        TRANSFER_QTY: {
          label: 'Transfer Qty',
          visible: true,
          disabled: true,
        },
        NEW_ON_HAND_QTY: {
          label: 'New On Hand Qty',
          visible: true,
          disabled: true,
        },
      },
      data: [],
      searchKeyword: '',
      toRecipients: [],
    };
    this.customLineInputChange = this.customLineInputChange.bind(this);
  }

  componentDidMount() {
    const {
      user,
      getTenants,
      getDocCFV2,
      match,
      getPurchaseRequests,
      selectedPurchaseRequest,
      purchaseRequests,
      getDocConfig,
    } = this.props;
    const { prId } = match.params;
    getTenants(1, '', true, user?.tenant_info?.org_id, 100, () => { });
    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName: 'STOCK_TRANSFER',
    };
    getDocCFV2(payload);

    const sourceTenantDepartmentId = selectedPurchaseRequest?.issuer_tenant_department_id ? selectedPurchaseRequest?.issuer_tenant_department_id : Helpers.getTenantDepartmentId(user);
    const sourceTenantId = selectedPurchaseRequest?.issuer_tenant_id ? selectedPurchaseRequest?.issuer_tenant_id : user?.tenant_info?.tenant_id;

    this.setState({
      sourceTenant: sourceTenantId,
      sourceDepartment: sourceTenantDepartmentId,
    });
    getPurchaseRequests(
      Helpers.getTenantEntityPermission(
        user?.user_tenants,
        Helpers.permissionEntities.PURCHASE_REQUEST,
        Helpers.permissionTypes.READ,
      )?.join(','),
      '',
      '',
      '',
      '',
      '',
      '',
      1,
      10,
      (prs) => {
        this.initStLines(prs, sourceTenantDepartmentId);
      },
      '',
      '',
      '',
      prId,
      sourceTenantDepartmentId,
    );
    getDocConfig(sourceTenantId, 'STOCK_TRANSFER');
  }

  initStLines(prs, sourceDepartmentId) {
    const { purchaseRequests, getUsers, cfV2DocStockTransfer } = this.props;
    const stockTransferLines = [];
    const prLines = prs?.purchase_requisition?.[0]?.purchase_requistion_lines;
    sessionStorage.setItem('staticReservations', JSON.stringify({}));
    for (let i = 0; i < prLines?.length; i++) {
      const prLine = prLines[i];
      const parentKey = uuidv4();
      stockTransferLines.push({
        pr_line_id: prLine?.pr_line_id,
        mo_line_id: prLine?.mo_line_id,
        product_sku_name: prLine?.product_sku_name,
        tenantProductId: prLine?.tenant_product_id,
        uom_name: prLine?.uom_name,
        uqc: prLine?.uqc,
        requested_qty: prLine?.quantity,
        department_quantities: prLine?.department_quantities,
        secondary_uom_dept_qty: prLine?.secondary_uom_dept_qty,

        // ((record?.available_qty / uomInfo?.ratio) * productUomInfo?.ratio)
        pending_qty: prLine?.quantity - prLine?.st_gen_quantity,
        quantity: Math.min(
          Helpers.getValueTotalInObject(
            this.getBatches(
              prLine?.product_batches,
              prLine?.quantity,
              sourceDepartmentId,
              prLine
            )?.filter((batch) => batch?.batch_in_use),
            "available_qty"
          ),
          prLine?.quantity - prLine?.st_gen_quantity
        ),
        expiry_days: prLine?.product_sku_info?.expiry_days,
        asset: prLine?.product_sku_info?.assets,
        sku: prLine?.tenant_product_id,
        availableQuantity: prLine?.available_qty,
        product_sku_info: prLine?.product_sku_info,
        manufacturingDateFormat:
          prLine?.product_sku_info?.manufacturing_date_format,
        expiryDateFormat: prLine?.product_sku_info?.expiry_date_format,
        uom_info: prLine?.uom_info,
        lineCustomFields: FormHelpers.lineSystemFieldValue(
          CustomFieldHelpers.getCfStructure(
            cfV2DocStockTransfer?.data?.document_line_custom_fields?.filter(
              (item) => item?.is_active
            )
          ),
          prLine?.pr_line_custom_fields ?? []
        ),
        product_batches: getBatchesWithReservation(
          Helpers.batchSelectionMethod(
            Helpers.getBatchMethod(prLine?.product_sku_info),
            prLine?.product_batches?.filter(
              (batch) => batch?.tenant_department_id === sourceDepartmentId
            ),
            prLine?.quantity
          ),
          Decimal.min(
            new Decimal(
              Helpers.getValueTotalInObject(
                this.getBatches(
                  prLine?.product_batches,
                  prLine?.quantity,
                  sourceDepartmentId,
                  prLine
                )?.filter((batch) => batch?.batch_in_use),
                "available_qty"
              )
            ),
            new Decimal(prLine?.quantity || 0).minus(
              prLine?.st_gen_quantity || 0
            )
          ).toNumber(),
          prLine,
          false,
          parentKey,
          true
        ),
        batchConsumptionMethod: Helpers.getBatchMethod(
          prLine?.product_sku_info
        ),
        isGoodStockOnly: false,
        key: parentKey,
      });
    }

    this.setState({
      selectedPurchaseRequest: prs?.purchase_requisition?.[0],
      selectedDate: dayjs(),
      remark: '',
      data: stockTransferLines,
      destinationDepartment:
        prs?.purchase_requisition?.[0]?.tenant_department_id,
      checkedRecipients: true,
    });
    getUsers(
      prs?.purchase_requisition?.[0]?.tenant_id,
      null,
      `${Helpers.permissionEntities.STOCK_TRANSFER}.${Helpers.permissionTypes.READ},${Helpers.permissionEntities.GOOD_RECEIVING}.${Helpers.permissionTypes.CREATE}`,
      (usersCallbackData) => this.setState({
        toRecipients: usersCallbackData?.data?.[0]?.tenant_user
          ?.filter((item) => item.is_active)
          .map((item) => item?.email),
      }),
    );
  }

  getBatches = (oldBaches, quantity, department, prLine, isGoodStockOnly) => {
    const batches = [];
    let remainingQty = new Decimal(quantity);

    for (let i = 0; i < oldBaches?.length; i++) {
      if (oldBaches[i]?.tenant_department_id === department) {
        const availableQty = new Decimal(oldBaches[i]?.available_qty || 0)
          .div(prLine?.uom_info?.ratio || 1)
          .mul(prLine?.product_sku_info?.uom_info?.ratio || 1);

        batches.push({
          ...oldBaches[i],
          consumed_qty: 0,
          available_qty: availableQty.toNumber(),
          batch_in_use: true,
        });
      }
    }

    for (let i = 0; i < batches?.length; i++) {
      const batch = batches[i];
      const availableQty = new Decimal(batch?.available_qty || 0);
      const alreadyConsumed = new Decimal(batch?.consumed_qty || 0);

      const isStockEligible = isGoodStockOnly ? !batch?.is_rejected_batch : true;

      if (isStockEligible && remainingQty.gt(0) && alreadyConsumed.lt(availableQty)) {
        const consumeQty = Decimal.min(availableQty, remainingQty);
        batch.consumed_qty = consumeQty.toNumber();
        remainingQty = remainingQty.minus(consumeQty);
      } else {
        batch.consumed_qty = 0;
      }
    }

    return batches;
  };

  static getDerivedStateFromProps(props, state) {
    if (props.cfV2DocStockTransfer?.data?.success && !state.isUserReadyOne) {
      return {
        ...state,
        cfStockTransferDoc:
          CustomFieldHelpers.getCfStructure(
            props.cfV2DocStockTransfer?.data?.document_custom_fields,
            true,
          ) || [],
        cfStockTransferLine:
          CustomFieldHelpers.getCfStructure(
            props.cfV2DocStockTransfer?.data?.document_line_custom_fields,
            true,
          ) || [],
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(
          props.cfV2DocStockTransfer?.data?.document_line_custom_fields,
          state.visibleColumns,
        ),
        data: state.data?.map((item) => ({
          ...item,
          lineCustomFields: CustomFieldHelpers.getDocumentCf(
            props.cfV2DocStockTransfer?.data?.document_line_custom_fields,
            [],
          ),
        })),
        isUserReadyOne: true,
      };
    }

    if (props.selectedPurchaseRequest && props.cfV2DocStockTransfer?.data?.success && !state.isUserReady) {
      const oldCustomField = props.selectedPurchaseRequest?.custom_fields || [];

      return {
        ...state,
        cfStockTransferDoc: CustomFieldHelpers.mergeCustomFields(props.cfV2DocStockTransfer?.data?.document_custom_fields, oldCustomField) || [],
        isUserReady: true,
      };
    }

    if (!state.terms) {
      if (props.docConfigStockTransfer) {
        const termsData = props.docConfigStockTransfer?.data
          ?.find((item) => item?.document_type === 'STOCK_TRANSFER_DOWNLOAD')
          ?.allowed_fields?.find(
            (field) => field?.field_name === 'default_t_and_c',
          )?.field_value;
        return {
          ...state,
          terms: termsData,
        };
      }
    }
    return {
      ...state,
    };
  }

  handleCreateSt = (withApproval) => {
    const { createSt, callback } = this.props;
    const {
      data,
      selectedDate,
      remark,
      sourceDepartment,
      destinationDepartment,
      fileList,
      selectedPurchaseRequest,
      cfStockTransferDoc,
      checkedRecipients,
      toRecipients,
      terms,
      initialStNumber,
      stNumber,
      docSeqId,
    } = this.state;
    this.setState({ formSubmitted: true });
    if (
      this.isDataValid()
      && (checkedRecipients ? toRecipients?.length : true)
      && selectedDate
      && sourceDepartment
      && destinationDepartment
      && !cfStockTransferDoc?.filter(
        (customField) => customField.isActive
          && customField.isRequired
          && (customField?.fieldType === 'ATTACHMENT'
            ? !customField?.fieldValue?.length
            : !customField?.fieldValue),
      )?.length
    ) {
      const getStBatches = (
        batches,
        sourceTenantProductId,
        destTenantProductId,
      ) => {
        const updatedBatches = [];
        for (let i = 0; i < batches?.length; i++) {
          const newBatch = {
            ...batches[i],
            quantity: batches[i]?.consumed_qty,
            source_tenant_product_id: sourceTenantProductId,
            destination_tenant_product_id: destTenantProductId,
            source_tenant_department_id: sourceDepartment,
            destination_tenant_department_id: destinationDepartment,
          };
          delete newBatch.tenant_department_id;
          delete newBatch.tenant_product_id;
          updatedBatches.push(newBatch);
        }
        return updatedBatches;
      };
      const stockTransferLines = [];
      for (let i = 0; i < data?.length; i++) {
        stockTransferLines.push({
          pr_line_id: data[i].pr_line_id,
          mo_line_id: data[i].mo_line_id,
          tenant_product_id: data[i]?.tenantProductId,
          quantity: data[i]?.quantity,
          secondary_uom_qty: data[i]?.product_sku_info?.secondary_uom_id ? Number(data[i]?.secondary_uom_qty ?? 0) : 0,
          uom_id: data[i]?.uom_info?.uom_id,
          uom_info: data[i]?.uom_info,
          // source_product_batches: getStBatches(data[i]?.product_batches?.filter((item) => item?.consumed_qty > 0), data[i]?.tenantProductId, null),
          source_product_batches: getStBatches(
            data[i]?.product_batches
              ?.filter((item) => item?.consumed_qty > 0)
              ?.map((batch) => ({
                ...batch,
                manufacturing_date: FormHelpers.dateFormatter(
                  batch?.manufacturing_date,
                  data[i]?.manufacturingDateFormat,
                ),
                expiry_date: FormHelpers.dateFormatter(
                  batch?.expiry_date,
                  data[i]?.expiryDateFormat,
                ),
              })),
            data[i]?.tenantProductId,
            null,
          ),
          custom_fields: CustomFieldHelpers.postCfStructure(
            data[i]?.lineCustomFields,
          ),
        });
      }
      const payload = {
        purchase_requisition_id:
          selectedPurchaseRequest?.purchase_requisition_id,
        source_tenant_department_id: sourceDepartment,
        destination_tenant_department_id: destinationDepartment,
        stock_transfer_date: selectedDate,
        custom_fields: CustomFieldHelpers.postCfStructure(cfStockTransferDoc),
        remark,
        status: withApproval ? 'ISSUED' : 'DRAFT',
        stock_transfer_lines: stockTransferLines,
        attachments:
          fileList?.map((attachment) => ({
            url: attachment?.response?.response?.location || attachment?.url,
            type: attachment.type,
            name: attachment.name,
            uid: attachment.uid,
          })) || [],
        notification_recipients: checkedRecipients ? toRecipients : [],
        t_and_c: global.isBlankString(terms) ? '' : terms,
        stock_transfer_number: initialStNumber?.toLowerCase()?.trim() === stNumber?.toLowerCase()?.trim() ? null : stNumber,
        seq_id: docSeqId || null,
      };
      createSt(
        payload,
        () => {
          this.setState({ currentAction: '' });
          callback();
        },
        withApproval,
      );
    } else {
      this.setState({ currentAction: '' });
    }
  };

  handleDelete(key) {
    const { data } = this.state;
    const copyData = data.filter((item) => item.key !== key);
    this.setState({ data: copyData });
  }

  handleChangeTextArea = (html) => {
    this.setState({ terms: html });
  };

  isDataValid() {
    const { user } = this.props;
    const { data, sourceDepartment, destinationDepartment } = this.state;
    const allowAccessTransferFromPr = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request
      ?.settings?.allow_excess_transfer_from_material_request;
    if (sourceDepartment == destinationDepartment) {
      notification.error({
        message: 'You have selected same source and destination department.',
        duration: 4,
        description:
          'Please select a different department to initiate stock transfer',
        placement: 'top',
      });
      return false;
    }
    let isDataValid = true;
    for (let i = 0; i < data.length; i++) {
      const currentProductId = data[i]?.product_sku_info?.product_sku_id;

      const totalQuantityPerProduct = data.reduce((sum, line) => {
        if (line?.product_sku_info?.product_sku_id === currentProductId) {
          const qty = Number(line.quantity || 0);
          const free = Number(line.free_quantity || 0);
          return sum + qty + free;
        }
        return sum;
      }, 0);
      if (
        !data[i].quantity
        || !data[i].product_sku_name
        || (data[i]?.sku
          && ((!allowAccessTransferFromPr
            && Number(data[i]?.pending_qty) - Number(data[i]?.quantity) < 0) // Only check pending_qty if allowAccessTransferFromPr is false
            || Number(totalQuantityPerProduct || 0)
            > Number(
              Helpers.getValueTotalInObject(
                data[i]?.product_batches?.filter((batch) => (data[i].isGoodStockOnly
                  ? !batch?.is_rejected_batch
                  : true && batch?.batch_in_use)),
                'available_qty',
              ),
            )
            || data[i]?.quantity < 0))
      ) {
        isDataValid = false;
        notification.open({
          type: 'error',
          message: 'Please check available quantity and quantity of products. ',
          duration: 4,
          placement: 'top',
        });
      }
    }
    return isDataValid;
  }

  getDataSource(data) {
    const copyData = JSON.parse(JSON.stringify(data));
    return copyData;
  }

  customInputChange(fieldValue, cfId) {
    const { cfStockTransferDoc } = this.state;
    const newCustomField = cfStockTransferDoc?.map((customField) => {
      if (customField?.cfId === cfId) {
        if (customField?.fieldType === 'ATTACHMENT') {
          return {
            ...customField,
            fieldValue: fieldValue?.map((attachment) => ({
              url: attachment?.response?.response?.location || attachment?.url,
              type: attachment.type,
              name: attachment.name,
              uid: attachment.uid,
            })),
          };
        }
        return {
          ...customField,
          fieldValue,
        };
      }
      return {
        ...customField,
      };
    });
    this.setState({
      cfStockTransferDoc: newCustomField,
    });
  }

  customLineInputChange(fieldValue, key) {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    for (let i = 0; i < copyData.length; i++) {
      if (copyData[i]?.key === key) {
        copyData[i].lineCustomFields = fieldValue;
      }
    }

    this.setState({ data: copyData });
  }

  toggleBatch(record, adjustmentRow) {
    const { data } = this.state;
    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.key === adjustmentRow?.key) {
        const rowBatches = data[i]?.product_batches;
        for (let j = 0; j < rowBatches?.length; j++) {
          if (rowBatches[j]?.batch_id === record?.batch_id) {
            rowBatches[j].batch_in_use = !rowBatches[j]?.batch_in_use;
            data[i].quantity -= rowBatches[j].consumed_qty;
            rowBatches[j].consumed_qty = 0;
          }
        }
        break;
      }
    }
    this.setState({ data });
  }

  getColumns() {
    const { user } = this.props;
    const { cfStockTransferLine, visibleColumns, formSubmitted } = this.state;
    const isSecondaryUomEnabled = user?.tenant_info?.global_config?.settings?.enable_secondary_uom;

    const productListColumns = [
      {
        title: 'PRODUCT',
        width: '350px',
        fixed: 'left',
        render: (text, record) => (
          <div>
            <Link
              to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`}
              target="_blank"
            >
              {record?.product_sku_info?.internal_sku_code}
            </Link>
            <H3Text text={record.product_sku_name} className="" />
            {record?.product_sku_info?.product_category_info?.category_path
              ?.length > 0 && (
                <ProductCategoryLabel
                  categoryPath={
                    record?.product_sku_info?.product_category_info?.category_path
                  }
                  categoryName={record?.product_sku_info?.product_category_info?.category_path?.at(
                    -1,
                  )}
                  containerStyle={{
                    width: 'fit-content',
                  }}
                />
              )}
          </div>
        ),
        visible: visibleColumns?.PRODUCT?.visible,
      },
      {
        title: 'AVAILABLE STOCK',
        width: '150px',
        render: (text, record) => {
          const { sourceDepartment } = this.state;
          const filteredDepartmentsStock = record?.department_quantities?.filter(
            (item) => item?.tenant_department_id !== sourceDepartment,
          );
          const totalStockInOtherDepartments = QUANTITY(filteredDepartmentsStock?.map((dept) => dept?.quantity).reduce((acc, cur) => acc + cur, 0) / record?.uom_info?.ratio, record?.uom_info?.precision);

          const hoverContent = (
            <div>
              {filteredDepartmentsStock?.map((dept) => (
                <div key={dept.department_id} className="other-uom-stock">
                  <H3Text text={dept?.alias_name} />
                  <H3Text
                    text={`${QUANTITY(dept?.quantity * (record?.product_sku_info?.uom_info?.ratio || 1) / (record?.uom_info?.ratio || 1) || 0, record?.product_sku_info?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}
                    className="tenant-inventory-slider__dept-qty"
                  />
                </div>
              ))}
            </div>
          );
          return (
            <Fragment>
              {Helpers.getValueTotalInObject(
                record?.product_batches?.filter((item) => (record?.isGoodStockOnly
                  ? !item?.is_rejected_batch
                  : true && item?.batch_in_use)),
                'available_qty',
              ) ? (
                `${QUANTITY(
                  Helpers.getValueTotalInObject(
                    record?.product_batches?.filter((item) => (record?.isGoodStockOnly
                      ? !item?.is_rejected_batch
                      : true && item?.batch_in_use)),
                    'available_qty',
                  ),
                  record?.uom_info?.precision,
                )} ${record?.uom_info?.uqc?.toProperCase()}`
              ) : (
                <span
                  style={{
                    color: 'red',
                    fontSize: '11px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  OUT OF STOCK
                </span>
              )}
              {Helpers.getValueTotalInObject(
                record?.product_batches?.filter((item) => item?.batch_in_use),
                'available_qty',
              ) > 0 && (
                  <H3Text
                    text={`In ${record?.product_batches?.filter(
                      (item) => item?.batch_in_use,
                    )?.length || '0'
                      } Batches`}
                    className="table-subscript"
                  />
                )}
              {totalStockInOtherDepartments > 0 && (
                <Popover
                  placement="bottom"
                  title="Stocks in other locations"
                  content={hoverContent}
                  trigger="hover"
                >
                  <div
                    className="table-subscript"
                    style={{
                      color: 'rgb(109 107 106)',
                    }}
                  >
                    {`+${QUANTITY(
                      totalStockInOtherDepartments,
                      record?.uom_info?.precision,
                    )}  ${record?.uom_info?.uqc?.toProperCase() || ''
                      } in other locations`}
                    <InfoCircleOutlined
                      style={{
                        color: 'rgb(45, 124, 246)',
                        margin: '2px',
                      }}
                    />
                  </div>
                </Popover>
              )}
              <br />
              {isSecondaryUomEnabled && `${QUANTITY(record?.secondary_uom_dept_qty[sourceDepartment] || 0, record?.product_sku_info?.secondary_uom_info?.precision)} ${record?.product_sku_info?.secondary_uom_info?.uqc?.toProperCase() || 'N/A'} (Secondary)`}
            </Fragment>
          );
        },
        visible: visibleColumns?.AVAILABLE_STOCK?.visible,
      },
      {
        title: 'REQUESTED QTY',
        width: '150px',
        render: (text, record) => `${QUANTITY(
          record?.requested_qty,
          record?.uom_info?.precision,
        )} ${record?.uom_info?.uqc?.toProperCase()}`,
        visible: visibleColumns?.REQUESTED_QTY?.visible,
      },
      {
        title: 'PENDING QTY',
        width: '150px',
        render: (text, record) => `${QUANTITY(
          record?.pending_qty,
          record?.uom_info?.precision,
        )} ${record?.uom_info?.uqc?.toProperCase()}`,
        visible: visibleColumns?.PENDING_QTY?.visible,
      },
      {
        title: 'TRANSFER QTY',
        width: '150px',
        render: (text, record) => {
          const { data } = this.state;
          const allowAccessTransferFromPr = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request
            ?.settings?.allow_excess_transfer_from_material_request;

          let availableQty = 0;
          let availableBatchQty = 0;

          availableQty = Helpers.getValueTotalInObject(record?.product_batches?.filter((item) => (item?.batch_in_use && (record?.isGoodStockOnly ? !item?.is_rejected_batch : true))), 'available_qty');

          const getEntries = (obj) => (obj ? Object.entries(obj) : []);

          const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));

          const batchIdsToSum = record?.product_batches?.filter((item) => (item?.batch_in_use && (record?.isGoodStockOnly ? !item?.is_rejected_batch : true)))?.map((item) => item?.batch_id) || [];

          const valuesToSum = batchIdsToSum?.flatMap((batchId) => getEntries(staticReservations[batchId])
            .filter(([lineId, value]) => lineId !== record?.key)
            .map(([lineId, value]) => value));

          const sum = valuesToSum.reduce((acc, value) => acc + value, 0);

          availableBatchQty = availableQty - sum;

          // Helper function to calculate if the quantity is valid
          let pendingQuantityFlag = false;
          let availableQuantityFlag = false;
          let invalidFormQuantityFlag = false;

          const isQuantityInvalid = (lineRecord) => {
            const quantity = Number(lineRecord?.quantity || 0);
            const currentProductId = lineRecord?.product_sku_info?.product_sku_id;

            const totalQuantityPerProduct = data.reduce((sum, line) => {
              if (line?.product_sku_info?.product_sku_id === currentProductId) {
                const qty = Number(line.quantity || 0);
                const free = Number(line.free_quantity || 0);
                return sum + qty + free;
              }
              return sum;
            }, 0);
            const pendingQtyLessThanZero = allowAccessTransferFromPr
              ? false
              : Number(lineRecord?.pending_qty) - quantity < 0;
            const quantityGreaterThanAvailableQty = totalQuantityPerProduct
              > Number(
                Helpers.getValueTotalInObject(
                  lineRecord?.product_batches?.filter((batch) => (record?.isGoodStockOnly
                    ? !batch?.is_rejected_batch
                    : true && batch?.batch_in_use)),
                  'available_qty',
                ),
              );
            const invalidFormQuantity = formSubmitted && quantity <= 0;
            if (pendingQtyLessThanZero) {
              pendingQuantityFlag = true
            }
            if (quantityGreaterThanAvailableQty) {
              availableQuantityFlag = true
            }
            if (invalidFormQuantity) {
              invalidFormQuantityFlag = true
            }

            return (
              pendingQtyLessThanZero
              || quantityGreaterThanAvailableQty
              || invalidFormQuantity
            );
          };
          // Helper function to handle the input change
          const handleInputChange = (event) => {
            const newQuantity = new Decimal(event.target.value || 0);
            const copyData = JSON.parse(JSON.stringify(data));
            const batches = JSON.parse(JSON.stringify(record?.product_batches));

            const pBatches = getBatchesWithReservation(batches, newQuantity.toNumber(), record, record?.isGoodStockOnly, record.key);

            let remainingQty = new Decimal(newQuantity);

            batches?.forEach((batch) => {
              batch.consumed_qty = 0;
            });

            batches?.forEach((batch) => {
              if (
                (record.isGoodStockOnly ? !batch.is_rejected_batch : true) &&
                batch.batch_in_use &&
                remainingQty.gt(0)
              ) {
                const availableQty = new Decimal(QUANTITY(batch.available_qty, record?.uom_info?.precision) || 0);
                const consumeQty = Decimal.min(availableQty, remainingQty);
                batch.consumed_qty = consumeQty.toNumber();
                remainingQty = remainingQty.minus(consumeQty);
              }
            });

            const updatedData = copyData?.map((item) => {
              if (item?.key === record.key) {
                item.quantity = newQuantity.toNumber();
                item.product_batches = pBatches;
              }
              return item;
            });

            this.setState({
              data: updatedData,
            });
          };

          return (
            <div>
              {isSecondaryUomEnabled && <span className="uom-label">{`Primary (${record.uom_info?.uqc || 'N/A'})`}</span>}
              <input
                value={record.quantity}
                type="Number"
                disabled={!record?.tenantProductId}
                onWheel={(event) => event.target.blur()}
                onChange={handleInputChange}
                className="orgFormInput"
              />
              {/* Display error message if quantity is invalid */}
              {/* {record?.sku && isQuantityInvalid(record) && (
                <div className="input-error">
                  *Entered quantity is more than available quantity or pending quantity
                </div>
              )} */}
              {record?.sku && isQuantityInvalid(record) && pendingQuantityFlag && (
                <div className="input-error">
                  *Entered quantity is more than pending quantity
                </div>
              )}
              {record?.sku && isQuantityInvalid(record) && availableQuantityFlag && (
                <div className="input-error">
                  *Entered quantity is more than available quantity
                </div>
              )}
              &nbsp;
              {isSecondaryUomEnabled && (
                <div className="st-qty-input">
                  <span className="uom-label">{`Secondary (${record.product_sku_info?.secondary_uom_info?.uqc || 'N/A'})`}</span>
                  <Input
                    value={record.secondary_uom_qty}
                    type="text"
                    disabled={!record?.tenantProductId || !record?.product_sku_info?.secondary_uom_id}
                    onWheel={(event) => event.target.blur()}
                    onChange={(event) => {
                      const newQuantity = event.target.value;

                      if (/^-?\d*\.?\d*$/.test(newQuantity)) {
                        const copyData = JSON.parse(JSON.stringify(data));

                        const updatedData = copyData?.map((item) => {
                          if (item?.key === record.key) {
                            item.secondary_uom_qty = newQuantity;
                          }
                          return item;
                        });
                        this.setState({
                          data: updatedData,
                        });
                      }
                    }}
                    className="orgFormInput"
                  />
                </div>
              )}
            </div>
          );
        },
        visible: visibleColumns?.TRANSFER_QTY?.visible,
      },
      {
        title: 'NEW ON HAND QTYY',
        width: '150px',
        // fixed: 'right',
        render: (item) => {
          const { data } = this.state;
          const currentProductId = item?.product_sku_info?.product_sku_id;

          const totalQuantityPerProduct = data.reduce((sum, line) => {
            if (line?.product_sku_info?.product_sku_id === currentProductId) {
              const qty = Number(line.quantity || 0);
              const free = Number(line.free_quantity || 0);
              return sum + qty + free;
            }
            return sum;
          }, 0);
          return (
            <Fragment>
              {item?.quantity >= 0 && item?.availableQuantity ? (
                <H3Text
                  text={`${QUANTITY(
                    Number(
                      Helpers.getValueTotalInObject(
                        item?.product_batches?.filter((batch) => (item?.isGoodStockOnly
                          ? !batch?.is_rejected_batch
                          : true && batch?.batch_in_use)),
                        'available_qty',
                      ),
                    ) - Number(totalQuantityPerProduct || '0'),
                    item?.uom_info?.precision,
                  )} ${item?.uom_info?.uqc?.toProperCase()}`}
                />
              ) : (
                '-'
              )}
            </Fragment>
          )
        },
        visible: visibleColumns?.NEW_ON_HAND_QTY?.visible,
      },
      {
        title: '',
        fixed: 'right',
        render: (text, record) => {
          const { data } = this.state;
          return (
            data.length !== record.key && (
              <div
                className="create-st__delete-line-button"
                onClick={() => {
                  this.handleDelete(record.key);
                }}
              >
                <CloseOutlined />
              </div>
            )
          );
        },
        visible: true,
        width: '40px',
      },
    ];

    if (cfStockTransferLine?.length) {
      productListColumns?.splice(
        4,
        0,
        ...CustomFieldHelpers.renderCustomLineColumns(
          false,
          cfStockTransferLine,
          visibleColumns,
          this.customLineInputChange,
          formSubmitted,
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          true
        ),
      );
    }

    return productListColumns.filter((item) => item.visible);
  }

  updateBatchValue(record, key, value, label, batchId) {
    const { data } = this.state;
    const copyData = JSON.parse(JSON.stringify(data));
    const updateData = copyData.map((obj) => {
      if (obj.key === key) {
        let productBatches = obj?.product_batches;
        productBatches = productBatches?.map((productBatch) => {
          if (productBatch.batch_id === batchId) {
            // Check if label is 'consumed_qty' and apply logic based on available_qty
            if (label === 'consumed_qty') {
              return {
                ...productBatch,
                [label]:
                  value > productBatch?.available_qty
                    ? productBatch?.available_qty
                    : value,
              };
            }
            // For other labels, simply update with the provided value
            return {
              ...productBatch,
              [label]: value,
            };
          }
          return productBatch;
        });
        // const tempQty = productBatches.reduce((sum, batch) => sum + (Number(batch.consumed_qty) || 0), 0);
        // productBatches = getBatchesWithReservation(productBatches, tempQty, obj, record?.isGoodStockOnly, key, false, batchId, value);
        // const qty = productBatches.reduce((sum, batch) => sum + (Number(batch.consumed_qty) || 0), 0);
        const tempQty = productBatches.reduce(
          (sum, batch) => sum.plus(new Decimal(batch.consumed_qty || 0)),
          new Decimal(0)
        );

        // Update productBatches using the decimal-based quantity
        productBatches = getBatchesWithReservation(
          productBatches,
          tempQty.toNumber(),
          obj,
          record?.isGoodStockOnly,
          key,
          false,
          batchId,
          value
        );

        // Calculate quantity after reservation
        const qty = productBatches.reduce(
          (sum, batch) => sum.plus(new Decimal(batch.consumed_qty || 0)),
          new Decimal(0)
        );
        return {
          ...obj,
          product_batches: productBatches,
          quantity: qty,
        };
      }
      return obj;
    });

    this.setState({
      data: updateData,
    });
  }

  render() {
    const {
      createStLoading,
      updateStLoading,
      user,
      getTenantsLoading,
      match,
      getStByIdLoading,
      selectedPurchaseRequest,
      history,
      getPurchaseRequests,
      department,
      getPurchaseRequestsLoading,
      getDepartments,
      users,
      departmentId,
      isOtherDepartmentStAllowed,
      getDocConfigStockTransferLoading,
      getDocConfig,
    } = this.props;
    const {
      productListColumns,
      data,
      remark,
      selectedDate,
      sourceTenant,
      currentAction,
      formSubmitted,
      sourceDepartment,
      fileList,
      cfStockTransferDoc,
      checkedRecipients,
      toRecipients,
      terms,
      initialStNumber,
      docSeqId,
      stNumber,
    } = this.state;
    const { prId } = match.params;

    const tenantId = selectedPurchaseRequest?.issuer_tenant_id ? selectedPurchaseRequest?.issuer_tenant_id : selectedPurchaseRequest?.tenant_id;

    const { userTenantDepartmentId, tenantDefaultStoreId } = Helpers.getUserTenantDepartmentIds(user, tenantId);

    /**
     * Determines if the Store Transfer (ST) action should be disabled based on department and tenant context.
     *
     * Logic:
     * - If the purchase request has an issuer department (i.e., it originated from another tenant department),
     * - And the issuer tenant is different from the requestor tenant,
     * - And the current user is not operating from the default store department,
     * Then the ST action should be disabled.
     *
     * @returns {boolean} if True ST should be disabled, otherwise false.
     */
    const isSTDisabledForOtherDepartment = () => {
      if (!selectedPurchaseRequest?.issuer_tenant_department_id) return false;

      return (
        selectedPurchaseRequest?.issuer_tenant_id !== selectedPurchaseRequest?.tenant_id &&
        userTenantDepartmentId !== tenantDefaultStoreId
      );
    };

    return (
      <div
        className={
          match.url.includes('/purchase-request')
            ? 'form__wrapper'
            : 'create-st__wrapper create-invoice-page'
        }
        style={{ padding: '0px 0px 80px 0px' }}
      >
        <Fragment>
          {getStByIdLoading ? (
            <div className="update-st__loading__wrapper">
              {[1, 2, 3, 4].map((item) => (
                <div key={item} className="update-st__loading__wrapper-row">
                  <div className="update-st__loading__wrapper-row__label loadingBlock" />
                  <div className="update-st__loading__wrapper-row__value loadingBlock" />
                </div>
              ))}
              <div className="update-st__loading__wrapper-table loadingBlock" />
              <div className="update-st__loading__wrapper-details loadingBlock" />
            </div>
          ) : (
            <Fragment>
              <div className="ant-row">
                <div className="ant-col-md-24">
                  <div className="form__section">
                    <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                      <H3Text text="PART A" className="form__section-title" />
                      <div className="form__section-line" />
                    </div>
                    <div className="form__section-inputs mg-bottom-20">
                      <div className="ant-row">
                        <DocumentNumberSeqInput
                          valueFromProps={stNumber}
                          setInitialDocSeqNumber={(value) => this.setState({ initialStNumber: value })}
                          entityName="STOCK_TRANSFER"
                          docSeqId={docSeqId}
                          tenantId={sourceTenant}
                          onChangeFromProps={(event, newValue, seqId) => {
                            this.setState({
                              stNumber: newValue ? (newValue || '') : (event?.target?.value || ''),
                              docSeqId: seqId,
                            })
                          }}
                          docTitle="Stock Transfer#"
                          formSubmitted={formSubmitted}
                        />
                        <div className="ant-col-md-6">
                          <div className="form__input-row">
                            <H3Text
                              text="Requestor Location"
                              className="form__input-row__label"
                            />
                            <H3FormInput
                              type="text"
                              disabled
                              containerClassName="orgInputContainer form__input-row__input"
                              labelClassName="orgFormLabel"
                              inputClassName="orgFormInput input"
                              placeholder=""
                              value={selectedPurchaseRequest?.tenant_info?.tenant_name}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className="form__input-row">
                            <H3Text
                              text="Requestor Department"
                              className="form__input-row__label"
                            />
                            <H3FormInput
                              type="text"
                              disabled
                              containerClassName="orgInputContainer form__input-row__input"
                              labelClassName="orgFormLabel"
                              inputClassName="orgFormInput input"
                              placeholder=""
                              value={department}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className="form__input-row">
                            <H3Text
                              required
                              text="Issuer Location"
                              className="form__input-row__label"
                            />
                            <div className="form__input-row__input">
                              <TenantSelector
                                selectedTenant={sourceTenant}
                                showSearch
                                onChange={(value) => {
                                  this.setState({
                                    sourceTenant: value,
                                    sourceDepartment: null,
                                    data: [],
                                  });
                                  getDepartments('', value, 1, 1000);
                                }}
                                disabled={userTenantDepartmentId !== tenantDefaultStoreId}
                                placeholder="Select issuer location.."
                                hideTitle
                                inputClassName="orgFormInput input"
                                labelClassName="form__input-row__label"
                                includedTenants={Helpers.getTenantEntityPermission(
                                  user?.user_tenants,
                                  Helpers.permissionEntities.STOCK_TRANSFER,
                                  Helpers.permissionTypes.CREATE,
                                )}
                              />
                            </div>
                          </div>
                          {formSubmitted && !sourceTenant && (
                            <div
                              className="input-error"
                              style={{
                                marginBottom:
                                  formSubmitted && !sourceTenant
                                    ? '10px'
                                    : '0px',
                                marginLeft: '200px',
                                marginTop: '0px',
                              }}
                            >
                              *Please select a source business unit
                            </div>
                          )}
                        </div>
                        {/* <SettingsInfo
                      settingName="Allow Stock Transfer from other departments"
                      path="/admin/configuration?tab=%2Fadmin-config%2Fpurchase-request&subTab=%2Fadmin-config%2Fpurchase-request%2Fgeneral"
                    /> */}
                        <div className="ant-col-md-6">
                          <div className="form__input-row">
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              <H3Text
                                text="Issuer Department"
                                className="form__input-row__label"
                              />
                              <div style={{ marginTop: '-10px' }}>
                                <SettingsInfo
                                  settingName="allow stock transfer from other departments"
                                  path="/admin/configuration?tab=%2Fadmin-config%2Fpurchase-request&subTab=%2Fadmin-config%2Fpurchase-request%2Fgeneral"
                                />
                              </div>
                            </div>
                            <div className="form__input-row__input">
                              <SelectDepartment
                                hideTitle
                                selectedDepartment={sourceDepartment}
                                onChange={(value) => {
                                  this.setState({
                                    sourceDepartment:
                                      value?.tenant_department_id,
                                  });
                                  getPurchaseRequests(
                                    Helpers.getTenantEntityPermission(
                                      user?.user_tenants,
                                      Helpers.permissionEntities
                                        .PURCHASE_REQUEST,
                                      Helpers.permissionTypes.READ,
                                    )?.join(','),
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    '',
                                    1,
                                    10,
                                    (prs) => {
                                      this.initStLines(
                                        prs,
                                        value?.tenant_department_id,
                                      );
                                    },
                                    '',
                                    '',
                                    '',
                                    prId,
                                    value?.tenant_department_id,
                                  );
                                }}
                                customStyle={{
                                  border: '1px solid rgba(68, 130, 218, 0.25)',
                                  borderRadius: '4px',
                                  height: '28px',
                                  padding: '0px',
                                  marginBottom:
                                    formSubmitted && !sourceDepartment
                                      ? '0px'
                                      : '10px',
                                }}
                                tenentLevelDepartment
                                tenantId={sourceTenant}
                                loading={getTenantsLoading}
                                disabled={
                                  isOtherDepartmentStAllowed
                                  || createStLoading
                                  || updateStLoading
                                  || isSTDisabledForOtherDepartment()
                                }
                                emptyNotAllowed
                                labelClassName="mo-form__input-row__label"
                                inputClassName="orgFormInput input"
                              />
                              {formSubmitted && !sourceDepartment && <div className="formError">*Please select a source department</div>}
                            </div>
                          </div>
                        </div>
                        {/* {formSubmitted && !sourceDepartment && (
                          <div
                            className="input-error"
                            style={{
                              marginBottom:
                                formSubmitted && !sourceDepartment
                                  ? '10px'
                                  : '0px',
                              marginLeft: '200px',
                              marginTop: '0px',
                            }}
                          >
                            *Please select a source department
                          </div>
                        )} */}
                        <div className="ant-col-md-6">
                          <div className="form__input-row">
                            <H3Text
                              required
                              text="Stock Transfer Date"
                              className="form__input-row__label"
                            />
                            <div className="form__input-row__input">
                              <DatePicker
                                value={selectedDate}
                                onChange={(value) => {
                                  this.setState({ selectedDate: value });
                                }}
                                loading={getTenantsLoading}
                                disabled={createStLoading || updateStLoading}
                                style={{
                                  border: '1px solid rgba(68, 130, 218, 0.2)',
                                  borderRadius: '2px',
                                  height: '28px',
                                  padding: '1px 3px',
                                  width: '100%',
                                  background: 'white',
                                }}
                              />
                            </div>
                          </div>
                          {formSubmitted && !selectedDate && (
                            <div
                              className="input-error"
                              style={{
                                marginBottom:
                                  formSubmitted && !selectedDate
                                    ? '10px'
                                    : '0px',
                                marginLeft: '200px',
                                marginTop: '0px',
                              }}
                            >
                              *Please select valid stock tranfer date
                            </div>
                          )}
                        </div>
                        <CustomFieldV3
                          customFields={cfStockTransferDoc || []}
                          formSubmitted={formSubmitted}
                          customInputChange={(value, cfId) => this.customInputChange(value, cfId)}
                          disableCase={createStLoading || updateStLoading}
                          isHorizontalUi
                          hideTitle
                          wrapperClassName="ant-col-md-6"
                          containerClassName="form__input-row"
                          labelClassName="form__input-row__label"
                          inputClassName="form__input-row__input"
                          errorClassName="form__input-row__input-error"
                          isCarryForward
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form__section ">
                    <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                      <H3Text text="PART B" className="form__section-title " />
                      <div className="form__section-line" />
                    </div>
                    <div className="form__section-inputs">
                      <div className="ant-row">
                        <div className="form__input-row">
                          <H3Text
                            text="Additional Remarks"
                            className="form__input-row__label"
                          />
                          <div className="form__input-row__input">
                            <textarea
                              rows="5"
                              cols="50"
                              onChange={(event) => {
                                this.setState({ remark: event.target.value });
                              }}
                              value={remark}
                              style={{
                                resize: 'none',
                                backgroundColor: 'rgb(239, 239, 239)',
                                border: 'none',
                                borderRadius: '4px',
                                marginRight: '15px',
                                height: '103px',
                                padding: '4px 8px',
                              }}
                            />
                          </div>
                        </div>
                        <div className="ant-col-md-6">
                          <div className="form__data-attachment">
                            <label className="form__input-row__label">
                              Attachment(s)
                            </label>
                            <Upload
                              action={Constants.UPLOAD_FILE}
                              listType="picture-card"
                              fileList={fileList}
                              // disabled={getSOByIdLoading}
                              multiple
                              onChange={(fileListData) => {
                                this.setState({
                                  fileList: fileListData?.fileList?.map(
                                    (item) => ({
                                      ...item,
                                      url: item?.response?.response?.location,
                                    }),
                                  ),
                                });
                              }}
                            >
                              {fileList?.length >= 20 ? null : uploadButton}
                            </Upload>
                          </div>
                        </div>
                        <div className="ant-col-md-24">
                          <div className="form__input-row">
                            <Checkbox
                              disabled={createStLoading || updateStLoading}
                              checked={checkedRecipients}
                              onChange={(event) => {
                                this.setState({
                                  checkedRecipients: event.target.checked,
                                });
                              }}
                            />
                            <span
                              style={{
                                fontWeight: '500',
                                fontSize: '12px',
                                marginLeft: '5px',
                              }}
                            >
                              Send Email Notification to Recipients
                            </span>
                          </div>
                        </div>
                        {checkedRecipients && (
                          <div className="ant-col-md-8">
                            <div className="form__inpu-row__input">
                              <PRZSelect
                                mode="tags"
                                value={toRecipients}
                                filterOption={false}
                                onChange={(value) => {
                                  const recipients = [];
                                  for (let i = 0; i < value?.length; i++) {
                                    if (Helpers.validateEmail(value[i])) {
                                      recipients.push(value[i]);
                                    }
                                  }
                                  this.setState({ toRecipients: recipients });
                                }}
                                disabled={createStLoading || updateStLoading}
                                maxTagCount="responsive"
                                showError={formSubmitted
                                  && checkedRecipients
                                  && !toRecipients?.length}
                                errorName="*Please enter at least one recipient"
                                errorClassName="formError"
                              >
                                {users
                                  && users?.data?.[0]
                                  && users?.data?.[0]?.tenant_user
                                    ?.filter((item) => item.is_active)
                                    .map((item) => (
                                      <Option
                                        key={item.user_id}
                                        value={item.email}
                                      >
                                        {item?.email}
                                      </Option>
                                    ))}
                              </PRZSelect>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form__lines-wrapper">
                      <Table
                        bordered
                        showHeader
                        size="small"
                        loading={
                          getPurchaseRequestsLoading
                          || createStLoading
                          || updateStLoading
                        }
                        columns={this.getColumns()}
                        dataSource={this.getDataSource(data)}
                        currentPage
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                        expandable={{
                          rowExpandable: (record) => Helpers.getValueTotalInObject(
                            record?.product_batches,
                            'available_qty',
                          ) > 0,
                          expandedRowRender: (record) => (
                            <BatchSelector
                              batches={record?.product_batches}
                              uomInfo={record?.uom_info}
                              expiryDays={record?.expiry_days}
                              itemsRow={record}
                              noCalculations
                              productUomInfo={
                                record?.product_sku_info?.uom_info?.[0] || record?.product_sku_info?.uom_info
                              }
                              onToggleBatch={(batch, adjustmentRow) => this.toggleBatch(batch, adjustmentRow)}
                              onBatchQuantityChange={(qty, batchId) => this.onBatchQuantityChange(
                                record?.key,
                                qty,
                                batchId,
                              )}
                              allStock={record?.isGoodStockOnly}
                              upDateAllStock={(value) => {
                                const copyData = JSON.parse(
                                  JSON.stringify(data),
                                );
                                const updatedData = copyData.map((item) => {
                                  if (item.key === record.key) {
                                    const newQuantity = record.quantity;
                                    const batches = record?.product_batches?.map(
                                      (batchData) => ({
                                        ...batchData,
                                        consumed_qty: 0,
                                      }),
                                    );
                                    let remainingQty = newQuantity;
                                    for (let i = 0; i < batches?.length; i++) {
                                      if (
                                        value
                                          ? !batches[i].is_rejected_batch
                                          : true
                                          && batches[i].batch_in_use
                                          && remainingQty > 0
                                          && Number(
                                            batches[i]?.consumed_qty || '0',
                                          ) < batches?.[i]?.available_qty
                                      ) {
                                        batches[i].consumed_qty = batches?.[i]?.available_qty
                                          > remainingQty
                                          ? remainingQty
                                          : batches?.[i]?.available_qty;
                                        remainingQty
                                          -= batches[i]?.consumed_qty;
                                      } else {
                                        batches[i].consumed_qty = 0;
                                        remainingQty
                                          -= batches[i]?.consumed_qty;
                                      }
                                    }
                                    return {
                                      ...item,
                                      isGoodStockOnly: value,
                                      product_batches: batches,
                                    };
                                  }
                                  return item;
                                });
                                this.setState({
                                  data: updatedData,
                                });
                              }}
                              updateBatchValue={(value, label, batchId) => this.updateBatchValue(
                                record,
                                record?.key,
                                value,
                                label,
                                batchId,
                              )}
                              batchMethod={record?.batchConsumptionMethod}
                              updateBatchConsumptionMethod={(value) => {
                                const copyData = this.getDataSource(data);
                                const sortedData = copyData?.map((item) => {
                                  if (record.key === item.key) {
                                    item.batchConsumptionMethod = value;
                                    item.product_batches = Helpers.batchSelectionMethod(
                                      value,
                                      item.product_batches,
                                      item.quantity,
                                      false,
                                      null,
                                      item?.uom_info,
                                    );
                                  }
                                  return {
                                    ...item,
                                  };
                                });
                                this.setState({ data: sortedData });
                              }}
                            />
                          ),
                        }}
                      />
                    </div>
                    <div className="create-st__summary-wrapper">
                      <div className="ant-row" style={{ marginTop: '15px' }}>
                        <div className="ant-col-md-12">
                          <div className="form__data-tc">
                            <label className="orgFormLabel">
                              Terms and Conditions
                            </label>
                            <RichTextEditor
                              onChange={(value) => this.handleChangeTextArea(value)}
                              disabled={
                                createStLoading
                                || updateStLoading
                                || getDocConfigStockTransferLoading
                              }
                              value={terms}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="create-st__footer" style={{ zIndex: '2' }}>
                      {Helpers.getPermission(
                        Helpers.permissionEntities.STOCK_TRANSFER,
                        Helpers.permissionTypes.CREATE,
                        user,
                      ) && (
                          <H3Button
                            text="Save as Draft"
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            customClass="create-st__footer-draft"
                            onClick={() => {
                              this.setState({ currentAction: 'SAVE_AS_DRAFT' });
                              if (!createStLoading || updateStLoading) {
                                this.handleCreateSt(false);
                              }
                            }}
                            isLoading={
                              currentAction === 'SAVE_AS_DRAFT'
                              && (createStLoading || updateStLoading)
                            }
                            disabled={createStLoading || updateStLoading}
                          />
                        )}
                      {Helpers.getPermission(
                        Helpers.permissionEntities.STOCK_TRANSFER,
                        Helpers.permissionTypes.CREATE,
                        user,
                      ) && (
                          <H3Button
                            text="Save And Issue"
                            buttonType={defaultButtonTypes.BLUE_ROUNDED}
                            customClass="create-st__footer-submit"
                            onClick={() => {
                              this.setState({ currentAction: 'SAVE_AND_ISSUED' });
                              if (!createStLoading || !updateStLoading) {
                                this.handleCreateSt(true);
                              }
                            }}
                            isLoading={
                              currentAction === 'SAVE_AND_ISSUED'
                              && (createStLoading || updateStLoading)
                            }
                            disabled={createStLoading || updateStLoading}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          )}
        </Fragment>
      </div>
    );
  }
}

const mapStateToProps = ({
  UserReducers,
  STReducers,
  TenantReducers,
  CFV2Reducers,
  PurchaseRequestReducers,
  DocConfigReducers,
}) => ({
  user: UserReducers.user,
  createStLoading: STReducers.createStLoading,
  updateStLoading: STReducers.updateStLoading,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  getStByIdLoading: STReducers.getStByIdLoading,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  cfV2DocStockTransfer: CFV2Reducers.cfV2DocStockTransfer,
  purchaseRequests: PurchaseRequestReducers.purchaseRequests,
  getPurchaseRequestsLoading:
    PurchaseRequestReducers.getPurchaseRequestsLoading,
  docConfigStockTransfer: DocConfigReducers.docConfigStockTransfer,
  getDocConfigStockTransferLoading:
    DocConfigReducers.getDocConfigStockTransferLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createSt: (payload, callback, withApproval) => dispatch(STActions.createSt(payload, callback, withApproval)),
  updateSt: (payload, callback, withApproval) => dispatch(STActions.updateSt(payload, callback, withApproval)),
  getTenants: (page, keyword, isVerified, orgId, limit, callback) => dispatch(
    TenantActions.getTenants(
      page,
      keyword,
      isVerified,
      orgId,
      limit,
      callback,
    ),
  ),
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(
    DepartmentActions.getDepartments(
      keyword,
      tenantId,
      page,
      limit,
      departmentId,
      callback,
    ),
  ),
  getStById: (tenantId, stId) => dispatch(STActions.getStById(tenantId, stId)),
  getStByIdSuccess: (selectedSt) => dispatch(STActions.getStByIdSuccess(selectedSt)),
  getDocCFV2: (paylaod, callback) => dispatch(CFV2Actions.getDocCFV2(paylaod, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getPurchaseRequests: (
    tenantId,
    status,
    fromDate,
    toDate,
    deliveryFromDate,
    deliveryToDate,
    tenantRoleId,
    page,
    limit,
    callback,
    searchKeyword,
    tenantDepartmentId,
    moId,
    prId,
    sourceDepartmentId,
  ) => dispatch(
    PurchaseRequestActions.getPurchaseRequests(
      tenantId,
      status,
      fromDate,
      toDate,
      deliveryFromDate,
      deliveryToDate,
      tenantRoleId,
      page,
      limit,
      callback,
      searchKeyword,
      tenantDepartmentId,
      moId,
      prId,
      sourceDepartmentId,
    ),
  ),
  getUsers: (tenantId, roleId, permissionType, callback) => dispatch(
    TenantActions.getUsers(tenantId, roleId, permissionType, callback),
  ),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(StockTransferPR));
